import { render, staticRenderFns } from "./EquipSysMgmt.vue?vue&type=template&id=0487ec20&scoped=true"
import script from "./EquipSysMgmt.vue?vue&type=script&lang=js"
export * from "./EquipSysMgmt.vue?vue&type=script&lang=js"
import style0 from "./EquipSysMgmt.vue?vue&type=style&index=0&id=0487ec20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487ec20",
  null
  
)

export default component.exports